import Vue from "vue";

import MobileCashing from "./MobileCashing.vue";

export function load() {
    const selector = "mobile-cashing";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(MobileCashing, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
